import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom'

import { cn } from '@/customer/lib/utils'

/**
 * Text link styled to match our design system. Wraps react-router's `Link` so
 * navigation, right-click-open, and keyboard behaviour are all handled for
 * free. Prefer this over react-router's `Link` throughout the customer app.
 */
export function Link({ className, ...props }: RouterLinkProps) {
  return (
    <RouterLink
      className={cn(
        'font-semibold text-foreground underline underline-offset-4 hover:text-foreground/70',
        className,
      )}
      {...props}
    />
  )
}
